<template>
  <div>
  <div v-if="addSimpleFormName">
    <el-button v-on:click="showDialog(addSimpleFormName,'新增')" v-bind:text="true" size="small">新增</el-button>
  </div>

  <FormUiQueryParam
      ref="formUiSimpleTableRef"
      v-if="tableConfig&&tableConfig.isQuery==1"
      v-bind:beanName="tableConfig.queryName"
      v-bind:removeFileds="[]"
      v-bind:queryParams="queryParams"
      v-bind:fieldGroupType="1"
      v-on:updateQueryParams="updateQueryParams"
      v-on:search="queryData">
    <template v-slot:btns="slotProps">
    </template>
  </FormUiQueryParam>
  <FormUiTable
      v-if="tableConfig"
      ref="formUiTableRef"
      v-bind:methodName="tableConfig.tableName"
      v-bind:isMenu="true"
      v-bind:isFilter="tableConfig.isFilter==1"
      v-bind:pageSize="pageSize"
      v-bind:editSimpleFormName="tableConfig.isBtnEdit==1?'editForm':''"
      v-bind:addSimpleFormName="tableConfig.isBtnAdd==1?tableConfig.addFormName:''"
      v-bind:deleteSimpleFormName="tableConfig.isBtnDel==1?'removeForm':''">
  </FormUiTable>
  </div>
</template>
<script>

import formuiService from './service/formui/FormuiService.js'
import FormUiTable from './FormUiTable.vue'
import formuiConfig from './formuiConfig.js'


export default {
  props: {
    tableName: String,
    isMenu: {
      type: Boolean,
      default: false
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    editSimpleFormName: String,
    deleteSimpleFormName: String,
    addSimpleFormName: String,
    pageSize: {
      type: Number,
      default: 20
    }
  },
  components: {
    FormUiTable
  },
  data() {
    return {
      tableConfig: null,
      simpleFormPath: '',
      queryParams: {}
    }
  },
  created() {
    this.simpleFormPath = formuiConfig.simpleFormPath
  },
  mounted() {
    Object.keys(this.$route.query).forEach(key => {
      this.queryParams[key] = this.$route.query[key]
    })

    this.loadData()
  },
  beforeRouteUpdate(to) {
    this.queryParams.pageNo = to.query.pageNo
    this.loadData()
  },
  methods: {
    handleCurrentChange(data) {
      this.queryParams.pageNo = data - 1
      this.goByParam()
    },
    goByParam() {
      delete this.queryParams.methodName
      this.$router.push({
        query: this.queryParams
      })
    },
    queryData(queryParams) {
      if (queryParams) {
        this.queryParams = queryParams
      }

      this.$refs['formUiTableRef'].loadData(this.queryParams)
    },
    loadData(queryParamsUpdate) {
      if (queryParamsUpdate) {
        this.queryParams = queryParamsUpdate
      }

      this.queryParams['tableName'] = this.$route.query.tableName

      if (this.tableName) {
        this.queryParams['tableName'] = this.tableName
      }

      formuiService.getFormUiSimpleTable(this,this.queryParams, (resp) => {
        console.log('resp', resp)
        this.tableConfig = resp
      }, (err) => {})
    },
    loadTableData(queryParamsUpdate) {
      if (queryParamsUpdate) {
        this.queryParams = queryParamsUpdate
      }
        this.$refs['formUiTableRef'].loadData(this.queryParams)

    },
    filterClear() {
      for (let i = 0; i < this.formuiTableRowList.length; i++) {
        if (typeof this.formuiTableRowList[i]['isShow'] === 'undefined') {
          this.formuiTableRowList[i].isShow = true
        }
        if (!this.formuiTableRowList[i].isShow && this.formuiTableRowList[i].isShow === false) {
          this.formuiTableRowList[i].isShow = true
        }
      }
      this.formuiTableRowFilterList = this.formuiTableRowList
    },
    filterCellValue() {
      if (!this.queryParams.filter) {
        this.filterClear()
        return
      }
      let filterArr = this.queryParams.filter.split(' ')
      console.log('filter:', filterArr)
      this.formuiTableRowFilterList = []
      for (let i = 0; i < this.formuiTableRowList.length; i++) {
        let showNum = 0
        outj:
        for (let k = 0; k < filterArr.length; k++) {
          if (filterArr[k] === '') {
            showNum++
            continue outj
          }
          for (let j = 0; j < this.formuiFieldList.length; j++) {
            if (this.formuiTableRowList[i].tableCellList[j].formatValue.indexOf(filterArr[k]) !== -1) {
              showNum++
              continue outj
            }
          }
        }
        if (showNum === filterArr.length) {
          this.formuiTableRowFilterList.push(this.formuiTableRowList[i])
        }
      }
    },
    checkDel(rowId) {
      if (confirm('确认删除?') === false) {
        return false
      }
      this.simpleFormAutoSubmit = true
      this.showSimpleForm = 1
      this.simpleFormTitle = '删除'
      if (!rowId) {
        console.error('异常，无id')
        return
      } else {
        this.simpleFormId = rowId
      }
      this.simpleFormName = this.deleteSimpleFormName
    },
    showDialog(formName, title, rowId) {
      this.simpleFormAutoSubmit = false
      this.showSimpleForm = 1
      this.simpleFormName = formName
      this.simpleFormTitle = title
      if (!rowId) {
        this.simpleFormId = null
      } else {
        this.simpleFormId = rowId
      }
    },
    closeDialog() {
      console.log('closeDialog2---------------------')
      this.showSimpleForm = 0
      this.tableConfig=null
    },
    submitCallback() {
      console.log('submitCallback---------------------')
      this.loadData()
    }
  }
}
</script>


// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiSimpleTable.vue